module.exports = __webpack_public_path__ + "static/img/jxsdw.e456503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jxsdw.png
// module id = oODn
// module chunks = 0